const roadmap = require('../../../../../app/Support/PlayingCards/KenoRoadmap.js')
module.exports = roadmap;


// WEBPACK FOOTER //
// ./resources/assets/js/keno/lib/KenoRoadmap.js